export enum DonationsIrelandStepEnum {
    PersonalDetails = 'Personal details',
    PostalAddress = 'Postal address',
    Location = 'Location of practice',
    DonationDetails = 'Donation details'
}